import {z} from 'zod';

import {DEALER_CLAIM_NUMBER_MAX_LENGTH} from '../constants/dealerClaimNumberMaxLength';

export const EvaClaimFormSchema = z.object({
  dealerClaimNumber: z.string().toUpperCase().nonempty().max(DEALER_CLAIM_NUMBER_MAX_LENGTH),
  repairStartDate: z.date(),
  repairEndDate: z.date().nullish(),
  mileageStart: z.number().min(0),
  mileageEnd: z.number().min(0).nullish(),
  claimText: z.string().nullish(),
  orders: z.array(
    z.object({
      serviceOrderId: z.string(),
      isSelected: z.boolean(),
    })
  ),
});

export type EvaClaimFormSchemaType = z.infer<typeof EvaClaimFormSchema>;
